import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "main-form" }
const _hoisted_3 = { class: "main-table" }
const _hoisted_4 = { class: "btns" }

import { useRouter } from "vue-router";
import {
  getUserList,
  getAllPosts,
  getAllDepart,
  getAllRole,
  delUser,
  getUserDetail,
} from "@/api/backstage";
import { reactive, ref, onMounted } from "vue";
import type { ElForm } from "element-plus";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import { ElMessage } from "element-plus";
import { ElConfigProvider } from "element-plus";
import Edit from "./Edit.vue";
type FormInstance = InstanceType<typeof ElForm>;

//  runSideEffectOnce();

import { defineComponent } from "vue";

const __default__ = {
  name: "用户信息",
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter();
let locale = zhCn;

const ruleFormRef = ref<FormInstance>();
const datas = reactive({
  drawer:false,
  userDetail:'',
  totle: 0,
  tableData: [],
  rows: "",
  roles: "",
  depart: "",
  dialogVisible: false,
});

const form = reactive({
  keyword: "",
  pageNum: 1,
  pageSize: 10,
  roleId: "",
  depId: "",
});

const getList = () => {
  getUserList(form).then((res) => {
    datas.tableData = res?.data.list ?? [];
    datas.total = res?.data.total ?? 0;
  });
};

const getDepart = () => {
  getAllDepart().then((res) => {
    datas.depart = res?.data ?? [];
  });
};

const getRole = () => {
  getAllRole().then((res) => {
    datas.roles = res?.data ?? [];
  });
};
const getDetail = (row) => {
  datas.drawer = true;
   getUserDetail(row.id).then((res) => {
    datas.userDetail = res?.data ?? '';
      datas.userDetail.fileUrl?   datas.userDetail.fileUrl =  localStorage.getItem("fileUrel") + datas.userDetail.fileUrl :'';
  });
};
 
const delUserList = (row) => {
  const baseId = { id: row.id };
  delUser(baseId).then((res) => {
    if (res.code === 200) {
      ElMessage({
        message: "操作成功",
        type: "success",
      });
      getList();
    } else {
      ElMessage({
        message: res.msg,
        type: "error",
      });
    }
  });
};

const handleSizeChange = (val: number) => {
  form.pageSize = val;
  getList();
};
const handleCurrentChange = (val: number) => {
  form.pageNum = val;
  getList();
};

const editClick = (row: any) => {
  datas.rows = row;
  datas.dialogVisible = true;
};
const resetForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.resetFields();
  getList();
};
onMounted(() => {
  getList();
  getDepart();
  getRole();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        inline: true,
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: form,
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
        class: "demo-form-inline"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "用户名",
            prop: "keyword"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.keyword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.keyword) = $event)),
                onKeyup: _withKeys(getList, ["enter","native"]),
                placeholder: "请输入"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "所属角色",
            prop: "roleId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: form.roleId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.roleId) = $event)),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.roles, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.description,
                      value: item.id,
                      key: index
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "所属部门",
            prop: "depId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: form.depId,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.depId) = $event)),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.depart, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.description,
                      value: item.id,
                      key: index
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: getList
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("搜索", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (resetForm(ruleFormRef.value)))
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("重置", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createTextVNode(" " + _toDisplayString(_ctx.total), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).push('/backstage/user/add')))
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createTextVNode("新 增", -1)
          ]))]),
          _: 1
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.route), 1)
      ]),
      _createVNode(_component_el_table, {
        data: datas.tableData,
        style: {"width":"100%"},
        "row-class-name": _ctx.tableRowClassName
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "index",
            width: "80",
            label: "序号"
          }),
          _createVNode(_component_el_table_column, {
            prop: "realName",
            label: "用户姓名",
            width: ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "roleName",
            label: "角色名称"
          }),
          _createVNode(_component_el_table_column, {
            prop: "staffNo",
            label: "职工号",
            width: ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "telephone",
            label: "联系电话"
          }),
          _createVNode(_component_el_table_column, {
            prop: "depName",
            label: "部门名称"
          }),
          _createVNode(_component_el_table_column, {
            prop: "createTime",
            label: "创建时间"
          }),
          _createVNode(_component_el_table_column, {
            prop: "sortNum",
            label: "操作"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_popconfirm, {
                "confirm-button-text": "是",
                "cancel-button-text": "否",
                icon: _ctx.InfoFilled,
                "icon-color": "red",
                title: "确认删除该条数据？",
                onConfirm: ($event: any) => (delUserList(row))
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_button, { type: "text" }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("删除", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["icon", "onConfirm"]),
              _createVNode(_component_el_button, {
                type: "text",
                onClick: ($event: any) => (_unref(router).push(`/backstage/user/edit?id=${row.id}`))
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("编辑", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "text",
                onClick: ($event: any) => (getDetail(row))
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode("详情", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "row-class-name"]),
      _createVNode(_unref(ElConfigProvider), { locale: _unref(locale) }, {
        default: _withCtx(() => [
          _createVNode(_component_el_pagination, {
            currentPage: form.pageNum,
            "page-size": form.pageSize,
            "page-sizes": [10, 20, 50, 100],
            small: _ctx.small,
            disabled: _ctx.disabled,
            background: "",
            layout: "total, sizes, prev, pager, next, jumper",
            total: datas.total,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["currentPage", "page-size", "small", "disabled", "total"])
        ]),
        _: 1
      }, 8, ["locale"]),
      (datas.dialogVisible)
        ? (_openBlock(), _createBlock(Edit, {
            key: 0,
            open: datas.dialogVisible,
            row: datas.rows,
            onClose: _ctx.close
          }, null, 8, ["open", "row", "onClose"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: datas.drawer,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((datas.drawer) = $event)),
      title: "用户详情",
      direction: _ctx.direction,
      size: 400,
      "before-close": _ctx.handleClose
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: datas.userDetail,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "用户名" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(datas.userDetail.realName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "头像" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_image, {
                  style: {"width":"70px","height":"70px"},
                  src:  datas.userDetail.fileUrl,
                  fit: "contain"
                }, {
                  error: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("div", { class: "image-slot" }, " 暂无图片 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "电子信箱" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(datas.userDetail.email), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "联系电话" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(datas.userDetail.telephone), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "出生日期" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(datas.userDetail.birthday), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "账号" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(datas.userDetail.username), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "身份证号码" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(datas.userDetail.idCard), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "职位" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(datas.userDetail.postName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "部门" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(datas.userDetail.depName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "工号" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(datas.userDetail.staffNo), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "创建时间" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(datas.userDetail.createTime), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "direction", "before-close"])
  ]))
}
}

})